import React, { cloneElement, useEffect, useState } from "react";
import AuthOne from "./components/auth1";
import AuthTwo from "./components/auth2";
import AuthThree from "./components/auth3";
import AuthFour from "./components/auth4";
import AuthFive from "./components/auth5";
import AuthSix from "./components/auth6";
import AuthSeven from "./components/auth7";
import AuthEight from "./components/auth8";
import AuthNine from "./components/auth9";
import { useLocation } from "react-router-dom";

const Side = ({ children, content, ...rest }) => {
  const location = useLocation();
  const isWelcome = location.pathname.includes("welcome");

  const slides = [
    // <AuthOne />,
    // <AuthTwo />,
    <AuthEight />,
    <AuthFour />,
    <AuthFive />,
    <AuthThree />,
    <AuthSix />,
    <AuthSeven />,
    <AuthNine />,
  ];

  const images = [
    // "/img/auth/1.png",
    // "/img/auth/2.jpg",
    "/img/auth/3.jpg",
    "/img/auth/4.jpg",
    "/img/auth/5.jpg",
    "/img/auth/6.jpg",
    "/img/auth/7.jpg",
    "/img/auth/8.jpg",
    "/img/auth/9.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(
      () => {
        setIsFading(true);
        setTimeout(() => {
          setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
          setIsFading(false);
        }, 750); // Fade-out süresi
      },
      [1, 2].includes(currentIndex) ? 4500 : 3000
    ); // Slaytlar arası bekleme süresi

    return () => clearInterval(interval);
  }, [slides.length, currentIndex]);

  return !isWelcome ? (
    <div className="grid lg:grid-cols-7 h-full">
      <div className="col-span-4 hidden lg:flex">
        <div className="relative flex-1 flex justify-center items-center">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`flex absolute inset-0 transition-opacity duration-500 ease-in-out w-full h-full ${
                index === currentIndex ? "opacity-100" : "opacity-0"
              }`}
            >
              {slide}
            </div>
          ))}
        </div>
      </div>
      <div className="bg-[#004656] col-span-3 flex flex-col justify-center items-center">
        {/* Arka plan resmi */}
        <div
          className={`lg:hidden absolute inset-0 transition-opacity duration-500 ease-in-out bg-no-repeat bg-cover ${
            isFading ? "opacity-0" : "opacity-100"
          }`}
          style={{ backgroundImage: `url(${images[currentIndex]})` }}
        ></div>
        <div className="xl:min-w-[450px] px-8 z-[10]">
          <div className="mb-8">{content}</div>
          {children ? cloneElement(children, { ...rest }) : null}
        </div>
      </div>
    </div>
  ) : (
    <div className="pt-10">
      {" "}
      {children ? cloneElement(children, { ...rest }) : null}
    </div>
  );
};

export default Side;
